module.exports = __webpack_public_path__ + "img/moment.3adb8ccb.png";